module.exports = __webpack_public_path__ + "static/media/continuous-integration.b9cc42a1.png";